import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NgForm, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { PatronesService, LoginService, } from '../../../../../services/';

import { Patron } from '../../../../../models';
import { MdOptionSelectionChange, MdDialog, MdCheckboxChange } from '@angular/material';
import { PreguntasObligatoriasComponent } from '../../preguntasobligatorias/preguntasobligatorias.component';
import { ToggleConfirmarComponent } from '../../../toggleConfirmar/toggleconfirmar.component';
import { async } from 'q';
// import { Patron } from '../../../../../models/patron/patron';
// import { Agrupacion } from '../../../../../models/patron/agrupacion';
// import { Pregunta } from '../../../../../models/patron/Pregunta';
// import { Respuesta } from '../../../../../models/patron/Respuesta';

@Component({
  selector: 'qs-programasdetalle',
  styleUrls: ['./programasdetalle.component.scss'],
  templateUrl: './programasdetalle.component.html',
  viewProviders: [ PatronesService, ],
  encapsulation: ViewEncapsulation.None,
})

export class ProgramasDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;
  private titulo: string;

  private idPaciente: string;
  private accion: string;
  private idValoracion: number;
  private _dialogServiceEliminar: ToggleConfirmarComponent;

  private patron: any;
  private idPatron: any;
  private oldPatron: Patron;
  private idRespuesta: string;
  private agrupaciones: any;
  private agrupacion: any;
  private preguntasExcluyentes: any;
  private fecha: string;
  public edadPaciente: string;
  public tipoEdad: string;
  public size: any;

  constructor(private _loadingService: TdLoadingService,
    private _dialogServiceConfirmar: TdDialogService,
    public media: TdMediaService,
    private _dialogService: MdDialog,
    private _router: Router,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.titulo = this._loginService.transient.textoPatron;
    this.patron = new Patron();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.patron = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('programasdetalle.load');
    this._changeDetectorRef.detectChanges();
    this.idValoracion = this.patron.idRespuesta;
    this.idRespuesta = String(this._loginService.transient.idRespuesta);

    let idPatron: number = this._loginService.transient.idPatron;
    this.titulo = this._loginService.transient.textoPatron;

    this._patronesService.obtenerPreguntasRespuestasPatronValorado(this.idRespuesta, this.idPaciente)
    .subscribe((res: any) => {

      this.patron = res.respuesta;
      this.idPatron = this.patron.patron;
      this.agrupaciones = res.respuesta.agrupaciones;
      this.preguntasExcluyentes = res.respuesta.preguntasExcluyentes;

      if (this.agrupaciones.length > 1) {
        this.size = true;
      } else {
        this.size = false;
      }

      // NECESARIO PARA DAR FORMATO TIPO DATE A LA VARIABLE FECHA PARA QUE
      // SEA RECONOCIDO POR EL DATEPICKER DEL FORMULARIO
      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          if (this.agrupacion[pregunta].respuestas.length > 0) {
            if (this.agrupacion[pregunta].respuestas[0].fecha !== undefined) {
              this.fecha = this.agrupacion[pregunta].respuestas[0].fecha;
              this.agrupacion[pregunta].respuestas[0].fecha = new Date(this.fecha);
            }
          }
        }
      }
      this._loadingService.resolve('programasdetalle.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('programasdetalle.load');
    });
    // this._changeDetectorRef.detectChanges();
  }

  delete(): void {
    this._dialogServiceEliminar = new ToggleConfirmarComponent(this._dialogServiceConfirmar);
    let mensaje: any = 'Pulse ACEPTAR para borrar el programa.';
    let titulo: any = 'Borrar Programa';

    this._dialogServiceEliminar.openConfirm(mensaje, titulo).subscribe((resp: any) => {

      if (resp) {
        this._patronesService.BorrarPatronPaciente(this.idPaciente, this.idValoracion.toString())
        .subscribe((res: any) => {
          if (res) {
            this._loginService.patron = res;
            this._loginService.mostrarMensaje('Programa eliminado correctamente.', 'OK', 6000);
            this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis', { outlets: { modanamnesis: ['programasfuncionales'] } }]);
          } else {
            this._loginService.mostrarMensaje('Error eliminando programa.', 'OK', 6000);
            this._loadingService.resolve();
          }
        }, (resError: Error) => {
          this._loginService.mostrarMensaje('Error procesando la eliminación', 'OK', 6000);
          this._loadingService.resolve();
        });
      }
    });

  }

  // save(form: NgForm): void {
  //   let validado: boolean;
  //   let fecha: Date = new Date();
  //   let message: string = '';
  //   let error: string = '';
  //   let messages: string[] = [
  //     'Programa añadido correctamente.', 'Error añadiendo Programa.',
  //     'Programa Actualizado correctamente.', 'Error actualizando Programa.',
  //     'Programa Borrado correctamente.', 'Error borrando Programa', ];
  //   let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
  //   switch (this.mode) {
  //     case 'edit':
  //       this.accion = 'M';
  //       message = messages[2];
  //       error = message[3];
  //       break;
  //     case 'add':
  //       this.accion = 'I';
  //       message = messages[0];
  //       error = messages[1];
  //       break;
  //     case 'del':
  //       this.accion = 'B';
  //       message = messages[4];
  //       error = messages[5];
  //       break;
  //     default: break;
  //   }

  //   validado = true; //this.verificarPreguntaObligatoria();

  //   if (!validado) {
  //     this.openDetail();
  //   }else{

  //       this._loadingService.register();
  //       let params: any = {
  //         iIdPatron: this.accion !== 'I' ? this.patron : '',
  //         iNumExpediente: this.idPaciente,
  //         iFecha: fecha,
  //         iDniMed: this._loginService.profesional.Dni,
  //       };
  //       this._patronesService.guardarPrograma(params).subscribe((res: any) => {
  //         if (res) {
  //           this._loginService.patron = res;
  //           this._loginService.mostrarMensaje(message, 'OK', 6000);
  //           this._loadingService.resolve();

  //           this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis',
  //           { outlets: { modanamnesis: ['programasfuncionales'] } }]);
  //         } else {
  //           this._loginService.mostrarMensaje(message, 'OK', 6000);
  //           this._loadingService.resolve();
  //         }
  //       }, (resError: Error) => {
  //         this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
  //         this._loadingService.resolve();
  //       });

  //   }
  // }

  save(form: NgForm): void {
    let validado: boolean;
    let fecha: Date = new Date();
    // let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    // this.idValoracion;
    validado = this.verificarPreguntaObligatoria();

    if (!validado) {
      this.openDetail();
    } else {
    // if (form.valid) {
      this._loadingService.register();
      let params: any = {
        idPatron: this.idPatron,
        idValoracion: this.idValoracion,
        textoPatron: this.titulo,
        numExpediente: this.idPaciente,
        fechaCumplimentacion: fecha,
        dniMedico: this._loginService.profesional.Dni,
        numVisita: this._loginService.consulta.visita,
        tipoEdad: this.tipoEdad,
        itemsPatron: this.agrupaciones,
      };

      let jparams: any = JSON.stringify(params);

      this._patronesService.HCI_OnCloud_GuardarModificacionDatosParaPatronCumplimentado(jparams)
      .subscribe((res: any) => {
        if (res) {
          this._loginService.patron = res;
          this._loginService.mostrarMensaje('Programa actualizado correctamente.', 'OK', 6000);
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis', { outlets: { modanamnesis: ['programasfuncionales'] } }]);
        } else {
          this._loginService.mostrarMensaje('Error actualizando programa.', 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando la actualización', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
    this._loadingService.resolve();

  }

  openDetail(): void {
    let dialogRef: any = this._dialogService.open( PreguntasObligatoriasComponent, {
      id: '11',
      width: '60%',
      role: 'dialog',
      height: '22%',
    });
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }

  actualizaRespuesta(event: MdOptionSelectionChange, idRespuesta: String, idPregunta: String): void {
    if (event.source.selected) {
      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          if (this.agrupacion[pregunta].idPregunta === idPregunta) {
            for (let respuesta in this.agrupacion[pregunta].respuestas) {
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta !== idRespuesta) {
                this.agrupacion[pregunta].respuestas[respuesta].seleccionada = false;
              }
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta === idRespuesta) {
                this.agrupacion[pregunta].respuestas[respuesta].seleccionada = true;
              }
            }
            break;
          }
        }
      }
      this.excluyePregunta(idRespuesta, idPregunta);
    }
  }

  actualizaRespuestaMultiple(event: MdCheckboxChange, idRespuesta: String, idPregunta: String): void {
    if (event.source.change) {
      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          if (this.agrupacion[pregunta].idPregunta === idPregunta) {
            for (let respuesta in this.agrupacion[pregunta].respuestas) {
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta === idRespuesta) {
                if (this.agrupacion[pregunta].respuestas[respuesta].seleccionada === true) {
                  this.agrupacion[pregunta].respuestas[respuesta].seleccionada = false;
                } else {
                  this.agrupacion[pregunta].respuestas[respuesta].seleccionada = true;
                }
              }
            }
          }
        }
      }
      this.excluyePregunta(idRespuesta, idPregunta);
    }
  }

  actualizaRespuestaTexto(inputValue: String, idPregunta: String): void {

    for (let grupo in this.agrupaciones) {
      this.agrupacion = this.agrupaciones[grupo].agrupacion;
      for ( let pregunta in this.agrupacion) {
        if (this.agrupacion[pregunta].idPregunta === idPregunta) {
          if (inputValue !== '') {
            this.agrupacion[pregunta].respuestas[0].idRespuesta = inputValue;
            this.agrupacion[pregunta].respuestas[0].seleccionada = true;
            break;
          } else {
            this.agrupacion[pregunta].respuestas[0].idRespuesta = undefined;
            this.agrupacion[pregunta].respuestas[0].textoRespuesta = '';
            this.agrupacion[pregunta].respuestas[0].seleccionada = false;
            break;
          }
        }
      }
    }
  }

  actualizarFecha(inputValue: Date, idPregunta: String): void {
    let fecha: any = this.dateFormat(inputValue);
    for (let grupo in this.agrupaciones) {
      this.agrupacion = this.agrupaciones[grupo].agrupacion;
      for ( let pregunta in this.agrupacion) {
        if (this.agrupacion[pregunta].idPregunta === idPregunta) {
          this.agrupacion[pregunta].respuestas[0].idRespuesta = inputValue.toLocaleDateString();
          this.agrupacion[pregunta].respuestas[0].seleccionada = true;
        }
      }
    }
  }

  excluyePregunta(idRespuesta: String, idPregunta: String): void {
    for (let grupo in this.agrupaciones) {
      this.agrupacion = this.agrupaciones[grupo].agrupacion;
      for (let pregunta in this.agrupacion) {
          for (let preguntaExcluyente in this.preguntasExcluyentes) {
            if ((idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTA) && (
                idRespuesta !== this.preguntasExcluyentes[preguntaExcluyente].MREX_IDRESPUESTAS)) {
                for (let preguntaNoExcluir in this.agrupacion) {
                  if (this.agrupacion[preguntaNoExcluir].idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTAEXCLUYE) {
                    this.agrupacion[preguntaNoExcluir].esExcluida = false;
                    this.agrupacion[preguntaNoExcluir].excluida = 'mostrar';
                  }
                }

            }
            if ((idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTA) && (
                idRespuesta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDRESPUESTAS)) {
              for (let preguntaAExcluir in this.agrupacion) {
                if (this.agrupacion[preguntaAExcluir].idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTAEXCLUYE) {
                  this.agrupacion[preguntaAExcluir].esExcluida = true;
                  this.agrupacion[preguntaAExcluir].excluida = 'ocultar';
                }
              }
            }
          }
      }

    }
  }

  verificarPreguntaObligatoria(): boolean {
    let validado: any = true;
    for (let grupo in this.agrupaciones) {
      let agrupacion: any = this.agrupaciones[grupo].agrupacion;
      for (let pregunta in agrupacion) {
        if (agrupacion[pregunta].obligatoria === 'S') {
          let respuestas: any = agrupacion[pregunta].respuestas;
          let preguntaActualizada: any = false;
          for (let respuesta in respuestas) {
            if (respuestas[respuesta].seleccionada === true) {
              agrupacion[pregunta].contestada = true;
              preguntaActualizada = true;
            }
          }
          if (agrupacion[pregunta].contestada === false && preguntaActualizada === false) {
            validado = false;
          }
          if (agrupacion[pregunta].contestada === true && preguntaActualizada === false) {
            // agrupacion[pregunta].contestada === false;
            agrupacion[pregunta].contestada = false;
            validado = false;
          }
        }
      }
    }
    return validado;
  }

  dateFormat(date: Date): String {
    let auxDate: any = date.toLocaleDateString();
    let secc: any = auxDate.split('/');
    let dia: any;
    let mes: any;
    let fecha: any;
    if ( secc[0].length === 1 ) {
        dia = '0' + secc[0].charAt(0);
    } else {
        dia = secc[0];
    }
    if ( secc[1].length === 1 ) {
        mes = '0' + secc[1].charAt(0);
    } else {
        mes = secc[1];
    }
    fecha = dia + '/' + mes + '/' + secc[2];

    return fecha;
  }

  openConfirmacion(): void {
    let dialogRef: any = this._dialogService.open( ToggleConfirmarComponent, {
      id: '12',
      width: '50%',
      role: 'dialog',
      height: '22%',
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/programasfuncionales/programasdetalle/programasdetalle.component.ts